import { useEffect, useState } from 'react';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const handler = (e) => setMatches(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** Aparelho tocado com o dedo. `pointer: coarse` é o teste certo — pega tablet
 *  e celular sem depender da largura da janela, que numa tela dividida mentiria
 *  nos dois sentidos. */
export function useIsTouch() {
  return useMediaQuery('(pointer: coarse)');
}
